import React from 'react'
import { formatCurrenctyWithoutSignal } from 'utils'
import { STATICS } from 'statics'
import './style.scss'

export function Card({ product, index, setSelectedProduct, selectedProduct }) {
  const { name, value: price, description2 } = product

  function handleClick() {
    setSelectedProduct(product)
  }

  function getIsSelected() {
    return selectedProduct?.id === product.id
  }

  function renderBestSeller() {
    const isFirst = index === 0

    if (!isFirst) return null

    return (
      <div className='container-best-seller'>
        <span className='text'>Mais assinado</span>
      </div>
    )
  }

  return (
    <button
      type='button'
      onClick={handleClick}
      className={`${getIsSelected() ? 'selected' : ''} container-card`}
    >
      {renderBestSeller()}
      <div className='container-upper'>
        <div className='container-info'>
          <span className='title'>{name}</span>
          <span className='price'>
            R$
            <span className='value'>{formatCurrenctyWithoutSignal(price)}</span> /mês
          </span>
        </div>
        <STATICS.CHECK />
      </div>
      <div className='container-lower'>
        <div className='container-image'>
          <STATICS.CARD_STAR />
        </div>
        <span className='text'>{description2}</span>
      </div>
    </button>
  )
}
